<form (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="row">
        <div class="form-group col-md-12">
            <validation [formGroup]="form" controlName="address1" displayName="Address line 1">
                <label for="address1">Address Line 1:</label>
                <input class="form-control"
                       formControlName="address1"
                       id="address1"
                       type="text"/>
            </validation>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-12">
            <label for="address2">Address Line 2:</label> <input class="form-control"
                                                                 formControlName="address2"
                                                                 id="address2"
                                                                 type="text"/>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="city" displayName="Town / city">
                <label for="city">Town / City:</label>
                <input class="form-control"
                       formControlName="city"
                       id="city"
                       type="text"/>
            </validation>
        </div>
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="province" displayName="Province / state">
                <label for="province"> Province / State:</label>
                <p-select [options]="provinceList"
                          class="form-control"
                          formControlName="province"
                          id="province"
                          optionLabel="value"
                          optionValue="value"></p-select>
            </validation>
        </div>
    </div>
    <div class="row">
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="postalCode" displayName="Postal code">
                <label for="postalCode">Postal Code:</label>
                <input class="form-control"
                       formControlName="postalCode"
                       id="postalCode"
                       type="text"/>
            </validation>
        </div>
        <div class="form-group col-md-6">
            <validation [formGroup]="form" controlName="billingEmailAddress" displayName="Billing email address">
                <label for="billing-email-address">Billing Email Address:</label>
                <input class="form-control"
                       formControlName="billingEmailAddress"
                       id="billing-email-address"
                       type="email"/>
            </validation>
        </div>
    </div>
    <div class="row justify-content-center justify-content-sm-center">
        <div class="btn-group mt-5">
            <button (click)="emitGoToPrevious()" class="navy-btn mr-3" type="button">
                <i class="fa fa-chevron-left fas"></i> &nbsp;Back
            </button>
            @if (!readOnly) {
                <button [disabled]="submitting" class="navy-btn ml-3" type="submit">
                    {{ submitLabel }}&nbsp; <i class="fa fa-save fas"></i>
                </button>
            }
        </div>
    </div>
</form>
<pre [hidden]="!isDeveloperMode()"><code>{{ getAllErrors(form) | json }}</code></pre>
